import api from "@lib/utils/api";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Layers } from "lucide-react";
import UniversCommercialViewPage from "@features/creation/univers-commerciaux/components/UniversCommercialViewPage";

export const Route = createFileRoute('/_app/creation/univers-commerciaux/$id/view')({
  loader: async (context) => {
    await requirePermission(PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.VIEW)({
      parentMatch: context.parentMatchPromise,
    });
    const { data } = await api.get(`/univers_commercials/${context.params.id}`);
    return data;
  },
  staticData: {
    title: "Détails univers",
    icon: Layers,
    permission: PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.VIEW,
    section: "Creation",
    order: 15,
    showInBreadcrumb: true,
  },
  component: ViewUniversCommercialPage,
});

function ViewUniversCommercialPage() {
  const universCommercial = Route.useLoaderData();

  return <UniversCommercialViewPage universCommercial={universCommercial} />;
}